import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './Toast.css';

const ICONS = {
  success: 'fa-check-circle',
  error: 'fa-times-circle',
  warning: 'fa-exclamation-triangle',
  info: 'fa-info-circle',
  achievement: 'fa-trophy'
};

const Toast = ({ id, message, type, title, icon, duration, onClose }) => {
  const { t } = useTranslation();
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    // Start exit animation before removal
    const exitTimer = setTimeout(() => {
      setIsExiting(true);
    }, duration - 300);

    return () => clearTimeout(exitTimer);
  }, [duration]);

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(onClose, 300);
  };

  const iconClass = icon || ICONS[type] || ICONS.info;

  return (
    <div
      className={`toast toast-${type} ${isExiting ? 'toast-exit' : ''}`}
      role="alert"
    >
      <div className="toast-icon">
        <i className={`fas ${iconClass}`} aria-hidden="true"></i>
      </div>
      <div className="toast-content">
        {title && <div className="toast-title">{title}</div>}
        <div className="toast-message">{message}</div>
      </div>
      <button
        className="toast-close"
        onClick={handleClose}
        aria-label={t('toast.closeAriaLabel', 'Close notification')}
      >
        <i className="fas fa-times" aria-hidden="true"></i>
      </button>
      <div
        className="toast-progress"
        style={{ animationDuration: `${duration}ms` }}
      />
    </div>
  );
};

export default Toast;
